import { useEffect, useState } from "react";
import PopupRemarks from "./PopupRemarks";
import { use } from "react";
import { Progress } from "../../../../nq-component";

function ResignationDetails({
  object,
  user,
  clickApprove,
  clickReject,
  inputDate,
  printExitForm,
  loading,
}) {
  console.log(object);
  const [tooltip, setTooltip] = useState(null);
  const [isAdminRemarks, setAdminRemarks] = useState(null);
  const [progress, setProgress] = useState(false);

  useEffect(() => {
    setProgress(loading);
  }, [loading]);

  const formatDate = (isoDate) => {
    if (!isoDate) return "N/A";
    const date = new Date(isoDate);
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };
  console.log(object);
  const getStatusClass = (status) => {
    switch (status) {
      case "Approved":
        return "text-success";
      case "Disapproved":
        return "text-danger";
      case "Pending":
        return "text-warning";
      case "In Progress":
        return "text-info";
      default:
        return "text-warning";
    }
  };

  const coordinatorName = object?.coordinator?.employee?.firstName
    ? `${object?.coordinator?.employee?.firstName} ${object?.coordinator?.employee?.lastName}`
    : "Coordinator";

  const recruiterName = object?.recruiter?.employee?.firstName
    ? `${object?.recruiter?.employee?.firstName} ${object?.recruiter?.employee?.lastName}`
    : "Recruiter";
  const signatories = [
    {
      name: coordinatorName,
      status: object?.coordinatorStatus,
      remarks: object?.coordinatorRemarks,
      position: "Coordinator",
    },
    {
      name: recruiterName,
      status: object?.recruiterStatus,
      remarks: object?.recruiterRemarks,
      position: "Recruiter",
    },
    {
      name: "HR",
      status: object?.hrStatus,
      remarks: object?.hrRemarks,
      position: "HR",
    },
    {
      name: "Accounting",
      status: object?.accountingStatus,
      remarks: object?.accountin,
      position: "Accounting",
    },
  ];

  const otherSignatories =
    object?.recruiterStatus !== undefined &&
    object?.coordinatorStatus !== undefined &&
    object?.hrStatus !== undefined &&
    object?.accountingStatus !== undefined;

  const isDisabled = (user) => {
    switch (user?.roles[0]?.id) {
      case "Admin":
        return (
          object?.status === "Approved" ||
          object?.status === "Disapproved" ||
          !otherSignatories
        );
        break;
      case "Recruiter":
        return object?.recruiterStatus !== undefined;
        break;
      case "Coordinator":
        return object?.coordinatorStatus !== undefined;
        break;
      case "HR":
        return object?.hrStatus !== undefined;
        break;
      case "Accounting":
        return object?.accountingStatus !== undefined;
        break;
    }
  };

  return (
    <div className="card mt-3 p-3 w-100 shadow-sm" style={{ fontSize: "12px" }}>
      <h6 className="fw-bold" style={{ color: "#d38740" }}>
        Resignation Details
      </h6>
      <p className="mb-1">
        <strong>Employee Name:</strong>{" "}
        {`${object?.employee?.firstName} ${object?.employee?.middleName} ${object?.employee?.lastName}`}
      </p>
      <p className="mb-1">
        <strong>Type of Resignation:</strong> {object?.resignationType}
      </p>
      <p className="mb-1">
        <strong>Effectivity Date:</strong> {formatDate(object?.effectiveDate)}
      </p>
      <p className="mb-1">
        <strong>Date Cleared:</strong> {formatDate(object?.separationDate)}
      </p>
      <p className="mb-1 d-flex gap-2">
        <strong>Status:</strong>
        <p
          className={`position-relative cursor-pointer ${getStatusClass(
            object?.status
          )}`}
          onMouseOver={() => setAdminRemarks(true)}
          onMouseLeave={() => setAdminRemarks(null)}
        >
          {object?.status || "N/A"}
          {isAdminRemarks && object?.adminRemarks ? (
            <PopupRemarks name={"Admin"} object={object} />
          ) : (
            ""
          )}
        </p>
      </p>

      {object?.employee?.exit_interview && (
        <>
          <div className="mb-2 d-flex flex-column col-12 col-lg-6">
            <strong>Exit Interview Form:</strong>
            <button
              className="btn text-white"
              style={{ backgroundColor: "#3174ad" }}
              onClick={printExitForm}
              disabled={progress}
            >
              {progress ? (
                <div className="d-flex gap-2 align-items-center">
                  <Progress className={"text-light"} size={"sm"} />
                  Printing...
                </div>
              ) : (
                <>
                  <i className="bi bi-file-earmark-text me-2 fw-bold" />
                  Exit Interview Form
                </>
              )}
            </button>
          </div>
        </>
      )}

      {/* <p className="mb-1">
        <strong>Resignation Letter:</strong>
        {object?.resignationLetter?.trim() ? (
          <div
            className="d-flex align-items-center justify-content-between p-2 mt-2"
            style={{
              backgroundColor: "#fbfbfb",
              borderRadius: "5px",
              border: "1px solid #ddd",
              maxWidth: "400px",
            }}
          >
            <div style={{ display: "flex", alignItems: "center" }}>
              <img
                src="https://cdn-icons-png.flaticon.com/512/337/337946.png"
                alt="PDF Icon"
                style={{ width: "20px", height: "20px", marginRight: "10px" }}
              />
              <span style={{ fontSize: "14px", wordBreak: "break-word" }}>
                {object.resignationLetter
                  .split("/")
                  .pop()
                  .split("_")
                  .slice(1)
                  .join("_") || "Resignation Letter"}
              </span>
            </div>
            <a
              href={object.resignationLetter}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                fontSize: "14px",
                color: "#007bff",
                textDecoration: "none",
              }}
            >
              View
            </a>
          </div>
        ) : (
          <span className="text-muted">No file attached</span>
        )}
      </p> */}

      <div>
        <strong>Assigned Signatories</strong>
        {signatories.map((signatory, index) => (
          <div
            key={index}
            className="position-relative d-flex justify-content-between px-2 my-2"
          >
            <p className="m-0">{signatory.name}</p>
            <p
              className={`m-0 position-relative cursor-pointer ${getStatusClass(
                signatory.status
              )}`}
              onMouseEnter={() => setTooltip(index)}
              onMouseLeave={() => setTooltip(null)}
            >
              {signatory.status || "Pending"}
              {tooltip === index && signatory.status !== undefined ? (
                <PopupRemarks name={signatory.position} object={object} />
              ) : (
                ""
              )}
            </p>
          </div>
        ))}
      </div>
      {user.roles[0].id === "Accounting" ? (
        <button
          className="btn bg-success text-white"
          disabled={object?.status !== "Approved" || !!object?.amount}
          onClick={inputDate}
        >
          <i class="bi bi-calendar-event"></i> Enter Last Pay Date
        </button>
      ) : (
        ""
      )}
      <div className="d-flex justify-content-between mt-3">
        <div
          className="position-relative flex-grow-1 me-2"
          onMouseEnter={() => setTooltip("approve")}
          onMouseLeave={() => setTooltip(null)}
        >
          <button
            className="btn text-white w-100"
            style={{ backgroundColor: "#D18237" }}
            onClick={clickApprove}
            disabled={isDisabled(user)}
          >
            <i className="bi bi-check"></i> Approve
          </button>
        </div>

        <div
          className="position-relative flex-grow-1"
          onMouseEnter={() => setTooltip("reject")}
          onMouseLeave={() => setTooltip(null)}
        >
          <button
            className="btn w-100"
            style={{ backgroundColor: "#DDDDDD" }}
            onClick={clickReject}
            disabled={isDisabled(user)}
          >
            <i className="bi bi-x"></i> Reject
          </button>
        </div>
      </div>
    </div>
  );
}

export default ResignationDetails;
